import { describeArc } from '../../../util/calculationUtils';
import classes from './Donut.module.scss';

interface Props {
  from: number;
  to: number;
  total: number;
  color: string;
  segmentIndex?: number;
  totalSegmentCount?: number;
}
const GAP_DEGREES = 1;

// Convert any value to a 360 degree angle
const valueToDegrees = (max: number, value: number): number => {
  if (max === 0) return 0;
  if (value >= max) return 359.99;
  return (value / max) * 360;
};

const DonutLayer = ({
  from,
  to,
  total,
  color,
  segmentIndex: index = 0,
  totalSegmentCount: totalCount = 1,
}: Props): JSX.Element | null => {
  const hasMultipleSegments = totalCount > 1;
  const gapAdjustment = hasMultipleSegments ? GAP_DEGREES : 0;
  const segmentGapOffset = index * gapAdjustment;
  // Get start and end angles for arc
  const startAngle = valueToDegrees(total, from);
  const endAngle = valueToDegrees(total, to);
  if (startAngle === endAngle) {
    return null;
  }
  const maxDegrees = 359.99 - gapAdjustment;
  const adjustedStartAngle = Math.min(startAngle + segmentGapOffset, maxDegrees);
  const adjustedEndAngle =
    Math.min(endAngle + segmentGapOffset, maxDegrees) - gapAdjustment;

  // Render
  return (
    <div className={classes.layer} aria-hidden="true">
      <svg
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        style={{ overflow: 'visible' }}
      >
        <path
          d={describeArc(50, 50, 40, adjustedStartAngle, adjustedEndAngle)}
          className={classes.path}
          stroke={color}
        />
      </svg>
    </div>
  );
};

export default DonutLayer;
